import { createSelector } from 'reselect';
import moment from 'moment';

const getPhaseAppointmentsSelector = state => state.phase.details.appointments || [];

export const momentizeAppointmentDates = appointments => appointments.map((appointment) => {
  const apptCopy = { ...appointment };
  apptCopy.start_moment = moment(`${appointment.start_date} ${appointment.arrival_start_time}`);
  apptCopy.end_moment = moment(`${appointment.end_date} ${appointment.arrival_end_time}`);
  if (appointment.appointment_confirmation_date) {
    apptCopy.appointment_confirmation_moment = moment(appointment.appointment_confirmation_date);
  }
  if (appointment.product_confirmation_date) {
    apptCopy.product_confirmation_moment = moment(appointment.product_confirmation_date);
  }
  if (appointment.pickup_date) {
    apptCopy.pickup_moment = moment(appointment.pickup_date);
  }
  return apptCopy;
});

export const momentizePhaseAppointmentDates =
  createSelector(
    getPhaseAppointmentsSelector,
    momentizeAppointmentDates,
  );

export const sortAppointments = appointments =>
  appointments.sort((a, b) => {
    if (a.start_moment.isBefore(b.start_moment)) return -1;
    if (a.start_moment.isAfter(b.start_moment)) return 1;

    return 0;
  });

export const sortPhaseAppointments =
  createSelector(
    momentizePhaseAppointmentDates,
    sortAppointments,
  );



// WEBPACK FOOTER //
// ./client/app/selectors/appointments.js